import { FilterOption } from '../../../components/_WMS/FilterComponent/types'
import {
  createBackendTransformer,
  createDisplayTransformer
} from '../../../types/filters'
import { SupplierOriginAutoCompleter } from '../components/SupplierOriginAutoCompleter'
import { SupplierAutoCompleter } from '../../Supplier20/components/SupplierAutoCompleter'

export const filterOptions: FilterOption[] = [
  {
    key: 'supplierId',
    label: 'Proveedor',
    type: 'custom',
    Component: SupplierAutoCompleter,
    order: 1,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'supplierOriginId',
    label: 'Origen',
    type: 'custom',
    Component: SupplierOriginAutoCompleter,
    order: 2,
    transformForBackend: createBackendTransformer(),
    transformForDisplay: createDisplayTransformer()
  },
  {
    key: 'active',
    label: 'Activo',
    type: 'precreated',
    order: 5
  },
  {
    key: 'isDraft',
    label: 'Draft',
    type: 'precreated',
    order: 6
  }
]
